import React from 'react'
import * as Errors from '@morningtrain/react-errors'

export default function PageLayout (props) {
  return (
    <div className='flex'>
      <div className='flex-col flex-grow overflow-x-auto p-6 sm:px-12 sm:py-8'>
        <Errors.Boundary>
          {props.children}
        </Errors.Boundary>
      </div>
    </div>
  )
}
